import { apiCurrentRound } from "./plugins/api";
import router from "./router";

router.beforeEach(async (to, from, next) => {
    const app_review_token = localStorage.getItem("app_review_token");
    if(to.path === '/' && app_review_token) {
        const res = await apiCurrentRound();
        if(res.code === 200 && res.data?.first_review_assignment_mode === 'work') {
            next({
                path: '/review_work',
                query: { 
                    round_id: res.data.id
                }
            })
        }
    } else {
        next();
    }
});